import styled from 'styled-components';

import { ReactComponent as FileText } from '../../assets/file-text.svg';
import { ReactComponent as Eye } from '../../assets/eye.svg';
import { ReactComponent as Download } from '../../assets/file-download.svg';

export const PageContainer = styled.div`
  min-height: 100vh;
  background: #f3f4f8;
  color: #222247;
  font-family: 'Biotif', sans-serif;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.header`
  width: 100%;
  padding: 20px 32px;
  background: #ffffff;
  border-bottom: 1px solid #e7e8ef;
  font-size: 1.8rem;
  font-weight: bold;
  color: #4948ac;
`;

export const Content = styled.main`
  flex: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 16px 32px;
`;

export const Footer = styled.footer`
  width: 100%;
  text-align: center;
  padding: 16px;
  font-size: 1.2rem;
  color: #6d7390;
`;

export const H1 = styled.h1`
  margin-bottom: 18px;
  margin-top: 18px;
  text-align: center;
  font-size: 24px;
  color: inherit;
  font-weight: 700;
`;

export const Logo = styled.img`
  margin-top 10px;
  margin-left: 10px
  max-width: 340px;
  width: 60%;
  height: auto;
`;

export const PolicyCard = styled.div`
  width: 100%;
  min-height: 50px;
  box-sizing: border-box;

  display: flex;
  align-items: center;

  padding: 24px 34px;

  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 24px;

  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 20px;
    padding: 24px;
  }
`;

export const FileIcon = styled.div`
  width: 60px;
  height: 60px;

  display: flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;

  background: #f0f1ff;
  border-radius: 20px;

  color: #4444b8;
`;

export const PolicyInfo = styled.div`
  margin-left: 32px;
  flex: 1;
`;

export const PolicyTitle = styled.h2`
  margin: 0 0 12px;

  font-size: 18px;
  font-weight: 600;

  color: #07194d;
`;

export const PolicyMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;

  font-size: 14px;
  color: #65718a;

  .separator {
    color: #a0a7b5;
  }
`;

export const PdfBadge = styled.span`
  display: inline-flex;
  align-items: center;

  padding: 5px 14px;

  border-radius: 18px;

  background: #ffe9e5;
  color: #e64b3c;

  font-size: 12px;
  font-weight: 700;
`;

export const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;

  margin-left: 30px;
`;

export const ViewButton = styled.a`
  height: 50px;
  min-width: 175px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;

  box-sizing: border-box;

  text-decoration: none;

  background: #ffffff;
  color: #4444b8;

  border: 2px solid #e4e7ef;
  border-radius: 18px;

  font-size: 16px;
  font-weight: 500;

  transition: all 0.2s ease;

  &:hover {
    background: #f7f7ff;
    border-color: #4444b8;
  }

  &:visited {
    color: #4444b8;
  }
`;

export const DownloadButton = styled.a`
  height: 50px;
  min-width: 250px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;

  box-sizing: border-box;

  text-decoration: none;

  background: #4444b8;
  color: #ffffff;

  border: 2px solid #4444b8;
  border-radius: 18px;

  font-size: 16px;
  font-weight: 500;

  transition: all 0.2s ease;

  &:hover {
    background: #3535a5;
    border-color: #3535a5;
  }

  &:visited {
    color: #ffffff;
  }
`;

export const FileTextIcon = styled(FileText)`
  width: 21px;
  height: 21px;
`;

export const EyeIcon = styled(Eye)`
  width: 21px;
  height: 21px;

  path {
    fill: #3535a5 !important;
  }
`;

export const DownloadIcon = styled(Download)`
  width: 21px;
  height: 21px;

  path {
    fill: #ffffff !important;
  }
`;
